<div class="container" [hidden]="enableSemRota || enableComRota">
    <div class="row">
        <div class="col text-center">
            <p>Viagem possui rota?</p>
        </div>
    </div>
    <div class="row">
      <div class="col text-center">
        <button type="button" class="btn btn-danger" (click)="enableSemRota=true">
            Sem rota
        </button>
      </div>
      <div class="col text-center">
        <button type="button" class="btn btn-success" (click)="enableComRota=true">
            Com rota
        </button>
      </div>
    </div>
</div>

<app-pre-checkout-viagem-sem-rota *ngIf="enableSemRota"></app-pre-checkout-viagem-sem-rota>
<app-pre-checkout-viagem-com-rota *ngIf="enableComRota"></app-pre-checkout-viagem-com-rota>